/* eslint-disable object-shorthand */
/* eslint-disable no-underscore-dangle */
/** @see {http://confluence.dixons.co.uk/display/DBS/Product+listing+-+postcode+checker#Productlisting-postcodechecker-RESPONSE} */
/** @description This is specifically an object to handle a subset of the full ProductAvailability
                    data returned by the multi-product check
                    In reality the full ProductAvailability object should inherit the ProductAvailabilityType object.
                    However, we don't have any JS inheritance pattern currently so this is a refactorable stop-gap.... */
/** @constructor */
/** @param {object} data */
/** @param {string} location */
function ProductAvailabilityType(data, location) {
  this.__data = data.data;
  this.__success = data.status === 'success';
  this.__location = location;
}
ProductAvailabilityType.prototype = {
  /** @returns {string} */
  getProductId: function() {
    return this.__data.productId;
  },

  /** @returns {string} */
  getLocation: function() {
    return this.__location;
  },

  /** @returns {string} */
  isSuccessful: function() {
    return this.__success;
  },

  /** @returns {string} */
  getDeliveryLabel: function() {
    return this.__data.postCodeCheck.label || '';
  },

  /** @returns {string} */
  getDeliveryState: function() {
    return this.__data.postCodeCheck.state || '';
  },

  /** @returns {boolean} */
  isDeliverable: function() {
    return this.getDeliveryState() === 'DELIVERABLE';
  },

  /** @returns {boolean} */
  isCollectable: function() {
    return this.getCollectionState() === 'COLLECTABLE';
  },

  /** @returns {string} */
  getCollectionState: function() {
    return this.__data.postCodeCheck.storeState || '';
  },

  /** @returns {string} */
  getCollectionLabel: function() {
    return this.__data.postCodeCheck.storeLabel || '';
  },

  /** @returns {string} */
  getProductType: function() {
    return this.__data.postCodeCheck.productType;
  },

  /** @returns {string} */
  getProductSegment: function() {
    return this.__data.postCodeCheck.segment;
  },

  /** @returns {string} */
  getAvailabilityInfo: function() {
    return this.__data.postCodeCheck.info;
  },

  /** @retuens {object} */
  getAnalytics: function() {
    return this.__data.postCodeCheckAnalytics || {
      soonestDelivery: null,
      soonestFreeDelivery: null
    };
  }
};

export default ProductAvailabilityType;
